import { createSlice } from "@reduxjs/toolkit";

export const partnerProfileSlice = createSlice({
  name: "partnerProfile",
  initialState: {
    partnerProfileData: {
      partnerId: 0,
      partnerTypeId: "-1",
      partnerCategoryNo: "-1",
      companyNickname: "",
      tinNumber: "",
      partnerStatus: "",
      address: "",
      zipCode: "",
      contactPerson: "",
      contactPerson2: "",
      contactPosition: "",
      contactPosition2: "",
      mobile: "",
      mobile2: "",
      landline: "",
      landline2: "",
      email: "",
      email2: "",
      ids: [],
      loadBalance: 0,
      paymentScheduleNo: "",
      featuresCod: 0,
      featuresShipout: 0,
      featuresReturns: 0,
      remarks: "",
      agentTopupAmount: 0,
      agentTopupSourceNo: -1,
      agentTopupThreshold: "",
      agentSourceFundNo: 0,
      walletBalance: "",
    },
  },
  reducers: {
    onPartnerProfileRender: (state, actions) => {
      var profileData = actions.payload;
      var tempIds = [];
      profileData.partnerAgentIdTypes.forEach((element) => {
        tempIds.push({
          value: element.idType.idTypeId,
          label: element.idType.idType,
        });
      });
      state.partnerProfileData = {
        partnerId: profileData.partnerId,
        partnerTypeId: profileData.partnerType.partnerTypeId,
        partnerCategoryNo:
          profileData.partnerType.partnerCategory.partnerCategoryNo,
        operatorId: profileData.operator.operatorId,
        companyNickname: profileData.companyNickname,
        tinNumber: profileData.tinNumber,
        address: profileData.address,
        zipCode: profileData.zipCode,
        contactPerson: profileData.contactPerson,
        contactPosition: profileData.contactPosition,
        mobile: profileData.mobile,
        landline: profileData.landline,
        email: profileData.email,
        contactPerson2: profileData.contactPerson2,
        contactPosition2: profileData.contactPosition2,
        mobile2: profileData.mobile2,
        landline2: profileData.landline2,
        email2: profileData.email2,
        ids: tempIds,
        featuresCod: profileData.featuresCod,
        featuresShipout: profileData.featuresShipout,
        partnerStatus: profileData.partnerStatus,
        featuresReturns: profileData.featuresReturns,
        paymentScheduleNo: profileData.paymentSchedule.paymentScheduleNo,
        remarks: profileData.remarks,
        loadBalance: profileData.loadBalance,
        agentTopupAmount: profileData.agentTopupAmount,
        agentTopupSourceNo: profileData.agentTopupSourceNo,
        agentTopupThreshold: profileData.agentTopupThreshold,
        agentSourceFundNo: profileData.agentSourceFundNo ?? 0,
        walletBalance: profileData.walletBalance,
      };
    },
    onPartnerProfileDataChange: (state, actions) => {
      switch (actions.payload.name) {
        case "partnerType":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              partnerTypeId: actions.payload.value,
            },
          };
        case "companyNickname":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              companyNickname: actions.payload.value,
            },
          };
        case "tinNumber": {
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              tinNumber: actions.payload.value,
            },
          };
        }
        case "address":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              address: actions.payload.value,
            },
          };
        case "zipCode": {
          // Validate the zip code using the regex pattern
          const zipCodeRegex = /^\d{4}$/;
          const isValidZipCode = zipCodeRegex.test(actions.payload.value);

          // if (!isValidZipCode) {
          // 	// If the zip code is invalid, you can handle it accordingly (e.g., show an error message)
          // 	return {
          // 		...state, // Keep the current state
          // 		error: "Invalid zip code", // Add an error message
          // 	};
          // }

          // If the zip code is valid, update the state
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              zipCode: actions.payload.value,
            },
            error: null, // Clear any previous error message
          };
        }
        case "partnerStatus":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              partnerStatus: actions.payload.value,
            },
          };
        case "contactPerson":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              contactPerson: actions.payload.value,
            },
          };
        case "contactPerson2":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              contactPerson2: actions.payload.value,
            },
          };
        case "contactPosition":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              contactPosition: actions.payload.value,
            },
          };
        case "contactPosition2":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              contactPosition2: actions.payload.value,
            },
          };
        case "mobile":
          const regexMobile = /^639d{9}$/;
          const isValidMobile = regexMobile.test(actions.payload.value);
          if (!isValidMobile) {
            // If the zip code is invalid, you can handle it accordingly (e.g., show an error message)
            // return {
            // 	...state, // Keep the current state
            // 	error: "Invalid", // Add an error message
            // };
          }

          // If the zip code is valid, update the state
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              mobile: actions.payload.value,
            },
            error: null, // Clear any previous error message
          };
        case "mobile2":
          const regexMobile2 = /^639d{9}$/;
          const isValidMobile2 = regexMobile2.test(actions.payload.value);
          if (!isValidMobile2) {
            // If the zip code is invalid, you can handle it accordingly (e.g., show an error message)
            // return {
            // 	...state, // Keep the current state
            // 	error: "Invalid", // Add an error message
            // };
          }

          // If the zip code is valid, update the state
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              mobile2: actions.payload.value,
            },
            error: null, // Clear any previous error message
          };
        case "landline": {
          // const regexLandline = /^[0-9-]*$/;
          // const isValidLandline = regexLandline.test(actions.payload.value);
          // // if (!isValidLandline) {
          // // 	// If the zip code is invalid, you can handle it accordingly (e.g., show an error message)
          // // 	return {
          // // 		...state, // Keep the current state
          // // 		error: "Invalid", // Add an error message
          // // 	};
          // // }

          // // If the zip code is valid, update the state
          // let formattedValue = actions.payload.value.replaceAll("-", "");

          // if (formattedValue.length === 11) {
          //   formattedValue =
          //     formattedValue.slice(0, 2) + "-" + formattedValue.slice(2);
          // } else if (formattedValue.length === 12) {
          //   formattedValue =
          //     formattedValue.slice(0, 3) + "-" + formattedValue.slice(3);
          // }
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              landline: actions.payload.value,
            },
            error: null, // Clear any previous error message
          };
        }
        case "landline2": {
          const regexLandline = /^[0-9-]*$/;
          // const isValidLandline = regexLandline.test(actions.payload.value);
          // // if (!isValidLandline) {
          // // 	// If the zip code is invalid, you can handle it accordingly (e.g., show an error message)
          // // 	return {
          // // 		...state, // Keep the current state
          // // 		error: "Invalid", // Add an error message
          // // 	};
          // // }

          // // If the zip code is valid, update the state
          // let formattedValue = actions.payload.value.replaceAll("-", "");

          // if (formattedValue.length === 11) {
          //   formattedValue =
          //     formattedValue.slice(0, 2) + "-" + formattedValue.slice(2);
          // } else if (formattedValue.length === 12) {
          //   formattedValue =
          //     formattedValue.slice(0, 3) + "-" + formattedValue.slice(3);
          // }
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              landline2: actions.payload.value,
            },
            error: null, // Clear any previous error message
          };
        }
        case "email":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              email: actions.payload.value,
            },
          };
        case "email2":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              email2: actions.payload.value,
            },
          };
        case "ids":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              ids: actions.payload.value,
            },
          };
        case "paymentScheduleNo":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              paymentScheduleNo: actions.payload.value,
            },
          };
        case "featuresCod":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              featuresCod: actions.payload.checked ? 1 : 0,
            },
          };
        case "featuresShipout":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              featuresShipout: actions.payload.checked ? 1 : 0,
            },
          };
        case "featuresReturns":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              featuresReturns: actions.payload.checked ? 1 : 0,
            },
          };
        case "remarks":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              remarks: actions.payload.value,
            },
          };

        case "agentTopupThreshold":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              agentTopupThreshold: actions.payload.value,
            },
          };
        case "agentTopupAmount":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              agentTopupAmount: actions.payload.value,
            },
          };
        case "agentTopupSourceNo":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              agentTopupSourceNo: actions.payload.value,
            },
          };
        case "agentSourceFundNo":
          return {
            ...state,
            partnerProfileData: {
              ...state.partnerProfileData,
              agentSourceFundNo: actions.payload.value,
            },
          };
        default:
          return state;
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { onPartnerProfileRender, onPartnerProfileDataChange } =
  partnerProfileSlice.actions;

export default partnerProfileSlice.reducer;
